import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


import React, { useState, useEffect } from 'react';

import { XLg } from 'react-bootstrap-icons';
import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';
import { ClearCookies } from '../../hooks/SessionID';

function LogoutForm(){
    /* Component Init */
    useEffect(() => {
        
    }, []);

    const submit = async (event: React.SubmitEvent) => {
        /* Don't reload page immediately so application can wait for API response */
        event.preventDefault();

        const posturl = process.env.REACT_APP_API_URL + "/v1/user/logout";
        const data = {};
        let axiosConfig = GetHeaders();
        

        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: data})
        console.log("Used the function...")
        console.log(response)

        //Successful response
        //remove saved session id
        //remove csrf token
        ClearCookies();
        window.location.reload(); 
    };

    return (
        <> 
            <Container>
                <Row className="">
                    <Col>
                        <form onSubmit={submit}>
                            <button type="submit" className="btn btn-secondary w-100">Logout</button>
                        </form>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default LogoutForm;